module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00058-fs8.aa88dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00058-fs8.png
// module id = 211
// module chunks = 0